import { render, staticRenderFns } from "./ThgVehicleOverview.vue?vue&type=template&id=2e4babf2&scoped=true"
import script from "./ThgVehicleOverview.vue?vue&type=script&lang=ts"
export * from "./ThgVehicleOverview.vue?vue&type=script&lang=ts"
import style0 from "./ThgVehicleOverview.vue?vue&type=style&index=0&id=2e4babf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4babf2",
  null
  
)

export default component.exports